import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/edit-pages',
        component: () => import('@/pages/pages/EditPageIndex.vue'),
        props: true,
        meta: {
            fullWidthContent: true,
        },
        children: [
            {
                name: 'edit-pages-index',
                path: '',
                component: () => import('@/components/pages/EditPagesList.vue'),
                meta: {
                    title: 'Edit Pages',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    // Check authorize in component level.
                    ability: { action: 'view all', subject: 'pages' },
                },
                props: true,
            },
            {
                name: 'edit-page-nested',
                path: 'nested/:folderSlug',
                component: () => import('@/components/pages/EditPagesList.vue'),
                meta: {
                    title: 'Edit Pages',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    // Check authorize in component level.
                    ability: { action: 'view all', subject: 'pages' },
                },
                props: true,
            },
            {
                path: 'create/:folderSlug',
                name: 'edit-page-create',
                component: () => import('@/components/pages/EditPageCreate.vue'),
                meta: {
                    title: 'Create Page',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'create', subject: 'page' },
                },
                props: true,
            },
            {
                path: 'create',
                name: 'edit-page-create-root',
                component: () => import('@/components/pages/EditPageCreate.vue'),
                meta: {
                    title: 'Create Pages',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'create', subject: 'page' },
                },
                props: true,
            },
            {
                path: ':slug/edit',
                name: 'edit-page-edit',
                component: () => import('@/components/pages/EditPageEdit.vue'),
                meta: {
                    title: 'Edit Pages',
                    middleware: [GateKeeperMiddleware],
                    // Check authorize in component level.
                    ability: { action: 'edit', subject: 'page' },
                },
                props: true,
            },
            {
                path: 'page-folders/create/:folderSlug',
                name: 'page-folder-create',
                component: () => import('@/components/pages/page-folders/PageFolderCreate.vue'),
                meta: {
                    title: 'Create Folder',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'create', subject: 'page folder' },
                },
                props: true,
            },
            {
                path: 'page-folders/create',
                name: 'page-folder-create-root',
                component: () => import('@/components/pages/page-folders/PageFolderCreate.vue'),
                meta: {
                    title: 'Create Folder',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'create', subject: 'page folder' },
                },
                props: true,
            },
            {
                path: 'page-folders/:folderSlug/edit',
                name: 'page-folder-edit',
                component: () => import('@/components/pages/page-folders/PageFolderEdit.vue'),
                meta: {
                    title: 'Edit Folder',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'edit', subject: 'page folder' },
                },
                props: true,
            },
        ],
    },
];
